import React from "react";
import CommonNudge from "./CommonNudge";

const parseNudgeContent = (text) => {
  try {
    return typeof text === "string" ? JSON.parse(text) : text || {};
  } catch {
    return { litLeadSubscriptionText: text || "" };
  }
};

const RedirectMessagePaymentNudge = ({
  item,
  handleClick,
  disable,
  onClose,
}) => {
  const content = parseNudgeContent(item?.text);
  const message = content?.litLeadSubscriptionText || "";
  const messageParts = message.split(/\n\s*\n/);
  const title = messageParts.shift() || "";
  const description = messageParts.join("\n\n");
  const buttonText =
    content?.litLeadSubscriptionLink || "Continue to Subscribe";

  const handleSubscribe = () => {
    if (disable) return;

    onClose?.();
    handleClick?.(
      item?.code,
      item?.data,
      "Redirect_Message_Payment",
      buttonText
    );

    if (item?.url) {
      window.open(item.url);
    }
  };

  return (
    <CommonNudge
      title={title}
      description={description}
      actionLabel={buttonText}
      onAction={handleSubscribe}
      onClose={onClose}
      disabled={disable}
      ariaLabel={content?.nudgeType || "Payment subscription reminder"}
    />
  );
};

export default RedirectMessagePaymentNudge;
